import styled from 'styled-components';

import {
  Page, NormalSection, HighlightSection,
  Header, TopTag, Title, BottomTag,
  Content, ContentTag, TextGroup, DropBorder, DropBox,
} from './components';

import solutionsHeaderImage from './images/solutions-header.jpg';
import designImage from './images/iStock-1163132207.jpg';

const SolutionsHeader = styled(Header)`
  background-image: url(${solutionsHeaderImage});
  background-repeat: no-repeat;
  background-size: 1460px auto;
  padding-top: 60px;
  padding-right: 20px;
  min-height: 700px;
  font-size: 1.6em;

  @media(max-width: 1000px) {
    font-size: 1.2em;
  }
`;

const DesignImage = styled.img`
  width: 100%;
  max-width: 1000px;
  max-height: 400px;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  display: block;
`;

const SolutionsTitle = styled(Title)`
  text-shadow: 1px 1px white;
`;

const SolutionsTag = styled(BottomTag)`
  color: black;
`;

const Solutions = () => {
  return (
    <Page>
      <NormalSection>
        <SolutionsHeader>
          <TopTag></TopTag>
          <SolutionsTitle>
            Enterprise Solutions For<br />
            Growing Businesses
          </SolutionsTitle>
          <SolutionsTag>
            Our team is your business's co-pilot.
          </SolutionsTag>
        </SolutionsHeader>
        <Content>
          <TextGroup>
            <DropBorder />
            <p>
              We treat your business with the same care as our own.
            </p>
            <p>
              We begin by learning about your processes and why you operate
              the way you do. We work together to understand your
              goals and vision. After we're clear on your "why", we will
              establish crystal-clear objectives and tasks for every
              project.
            </p>
            <p>
              Next, you and your team will review the project itinerary
              and add comments. We’ll make any adjustments needed—and we
              won’t start developing until we have your full approval.
            </p>
            <p>
              Finally, you’ll get a bird’s eye view of every project with
              our own custom project management
              system, <i>Altitude</i>. <i>Altitude</i> allows you
              to always see what stage of the journey your project is in,
              view projected timelines, and even submit change requests and
              trouble tickets.
            </p>
            <p>
              Our end-to-end experience includes creating a roadmap for
              success, developing and testing your solution, and providing
              ongoing maintenance and support.
            </p>
          </TextGroup>
        </Content>
      </NormalSection>
      <HighlightSection className="dark-highlight">
        <Content>
          <ContentTag>
            Enterprise Solutions for Growing Businesses
          </ContentTag>
          <div style={{position: 'relative'}}>
            <TextGroup>
              <DropBorder />
              <p>
                We believe in building software that supports your business
                and its processes. Isn’t it so frustrating when a tool doesn’t
                match your workflow? Our custom ERP software development is
                aimed at building a scalable business-tailored system
                that integrates all business management functions and
                facilitates data-driven decision-making.
              </p>
            </TextGroup>
            <DropBox />
          </div>
        </Content>
      </HighlightSection>
      <NormalSection>
        <Content>
          <ContentTag>
            Web Application Development Custom-Built for You
          </ContentTag>
          <TextGroup>
            <DropBorder />
            <p>
              Did you know 75% of users prefer a mobile-friendly web app?
              And yet 96% of users reported experiencing issues while
              using mobile. Many businesses find themselves running out of
              runway because their business applications aren’t ready to travel.
            </p>
            <p>
              With us, you’ll get software that’s so much more than a
              customized CRM solution—you’ll get an experience that’s accessible
              to your customers and leadership alike. We treat your business
              like our very own, starting with understanding your core
              principles and goals. Then, we create your software with the
              features and functionalities you actually need.
            </p>
          </TextGroup>
        </Content>
      </NormalSection>
      <HighlightSection className="dark-highlight">
        <Content>
          <ContentTag>
            Mobile Application Development for Your Clients,
            Customers, and Employees
          </ContentTag>
          <div style={{position: 'relative'}}>
            <TextGroup>
              <DropBorder />
              <p>
                People today expect ease and convenience from your mobile app,
                but they expect security too. Our team focuses on developing a
                quick, secure, and encrypted interface for everything from logging
                in to sharing payment info.
              </p>
              <p>
                Whether your mobile app needs are big or small, we stay committed
                to establishing clear goals and taking steps to get there. From
                clocking in to tracking inventory, our experts have the experience
                and dedication to create a flawless, custom mobile solution for
                your business needs.
              </p>
            </TextGroup>
            <DropBox />
          </div>
        </Content>
      </HighlightSection>
      <NormalSection>
        <DesignImage src={designImage} alt="Designing layouts" />
      </NormalSection>
    </Page>
  );
};

export default Solutions;
